import { render, staticRenderFns } from "./SupervisionForm.vue?vue&type=template&id=6bd41ffa&scoped=true"
import script from "./SupervisionForm.vue?vue&type=script&lang=js"
export * from "./SupervisionForm.vue?vue&type=script&lang=js"
import style0 from "./SupervisionForm.vue?vue&type=style&index=0&id=6bd41ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd41ffa",
  null
  
)

export default component.exports